import type { EventStatus, ProgramEventListType, ProgramEventStatus } from 'models';
import { useMemo } from 'react';
import { RadarLineIcon, type TagProperties } from 'ui';
import { useGetEventTypeTagProperties } from './useGetEventTypeTagProperties';
import { useShouldShowLiveTag } from './useShouldShowLiveTag';

export const useGetEventTagsProperties = ({
  endTime,
  eventType,
  startTime,
  status,
}: {
  endTime: Date;
  eventType: ProgramEventListType;
  startTime: Date;
  status: EventStatus | ProgramEventStatus;
}): TagProperties[] => {
  const getEventTypeTagProperties = useGetEventTypeTagProperties();
  const shouldShowLiveTag = useShouldShowLiveTag({ endTime, eventType, startTime, status });

  return useMemo(() => {
    const liveTag: TagProperties = {
      children: 'Live',
      color: 'live',
      format: { upperCase: true },
      icon: <RadarLineIcon />,
      key: 'live',
    };

    return [
      {
        ...getEventTypeTagProperties({ eventType }),
        key: 'event-type',
      },
      ...(shouldShowLiveTag ? [liveTag] : []),
    ];
  }, [getEventTypeTagProperties, eventType, shouldShowLiveTag]);
};
